<template>
    <div class="card">
        <div class="flex justify-content-between">
            <h5>{{ label('Debrief') }} Reports</h5>
            <div class="flex justify-content-start gap-2">
                <Button v-if="showPrintReportButton" :label="printButtonLabel" class="p-button-warning" @click="printReport" :loading="isLoading" />
                <a :href="downloadLink" target="_blank" class="text-white"><Button label="Download Report" v-if="downloadLink && !isLoading" /></a>
            </div>
        </div>
        <!-- Debrief Report Criteria Section Here -->
        <DebriefReportCriteria @set-criteria="setCriteria" />

        <div class="flex flex-column gap-2">
            <!-- =====> Banner of Result data -->
            <DebriefReportResultBar :totalRecords="totalDebriefRecords" />
            <!-- =====> Debrief Charts -->
            <DebriefReportCharts :criteriaSet="setCriteriaValue" />
            <!-- =====> Debrief ReportTable -->
            <DebriefReportTable @table-loaded="setDebriefRecordsCount" :criteriaSet="setCriteriaValue" />
        </div>
    </div>
</template>

<script setup>
import DebriefReportCriteria from '../modules/debrief-reports/DebriefReportCriteria.vue';
import DebriefReportResultBar from '../modules/debrief-reports/DebriefReportResultBar.vue';
import DebriefReportCharts from '../modules/debrief-reports/DebriefReportCharts.vue';
import DebriefReportTable from '../modules/debrief-reports/DebriefReportTable.vue';

import { ref, computed } from 'vue';
import { reportStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

const isLoading = ref(false);
const downloadLink = ref(null);
const totalDebriefRecords = ref(null);
const setCriteriaValue = ref(false);

// Debrief Report Computed Properties
// Make sure everything is loaded, and we have enough data to make proper request before requesting to print out
const showPrintReportButton = computed(() => {
    return totalDebriefRecords.value ?? false;
});

const printButtonLabel = computed(() => {
    return isLoading.value ? 'Printing Report...' : 'Print Report';
});
const setDebriefRecordsCount = (debriefCount) => {
    totalDebriefRecords.value = debriefCount;
};

const setCriteria = () => {
    setCriteriaValue.value = !setCriteriaValue.value;
};

const printReport = async () => {
    try {
        isLoading.value = true;
        // 1: Request to store to fetch report data for printing
        //  Make sure to send the total records count as well
        downloadLink.value = await reportStore.printDebriefReport(totalDebriefRecords.value);

        // 1: fetch template response from the api
        // const templateResponse = await reportStore.generateDebriefTemplateResponse();
        // 2: Format template payload
        // const templatePayloadJson = formatTemplateResponse(templateResponse.data);
        // console.log('Template payload', templatePayloadJson);
        // 3: Print report
        // downloadLink.value = await reportStore.downloadReport(templatePayloadJson, 'debrief');
    } catch (error) {
        showToast({}, 'Error while printing debrief report');
    } finally {
        isLoading.value = false;
    }
};
</script>
